/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import moment from 'moment';
import green from './../../img/green.png';
import warning from './../../img/warning.png';
import failure from './../../img/failure.png';
import info from './../../img/info.png';
import PropTypes from 'prop-types';
export default class healthDashboard extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			selectedPage: 0,
			s3APIStatusJson: this.loadData('/health-status/health-status.json')			
		};
	}

	loadData = (url) => {
		url = url+"?"+Date.now();
		fetch(url).then(function (response) {
			if (response.ok) {
				return response.json();
			}
			throw new Error('Error message.');
		}).then(function (data) {
			this.setState({ s3APIStatusJson: data });
		}.bind(this)).catch(function (err) {
			console.log("failed to load ", url, err.message);
			this.setState({ s3APIStatusJson: [] });
		});
	}

	handlePageSelection = (id) => {
		this.setState({ selectedPage: id });
	};
	renderStatusTime() {
		let fromNowDate = "";
		let dateString = "";
		if(this.state.s3APIStatusJson){			
			fromNowDate = moment(this.state.s3APIStatusJson.timestamp).fromNow();
			dateString = moment(this.state.s3APIStatusJson.timestamp).toDate();
		} 
		return [dateString, fromNowDate]
	 }
	renderTableHeader() {
		let header = ["Products and Services", "DDOA", "Source System"];
		return header.map((key, index) => {
		   return ( <th key={index}>{key}</th> );
		})
	}
	getStatusClass(status) {
		let cssClass = "info-icon-th";
		let statusThIcon = info;
		let imgTag ="---";
		switch (status) {
			case "Failure":
				cssClass = "failure-icon-th";
				statusThIcon = failure;
				break;
			case "Good":
				cssClass = "green-icon-th";
				statusThIcon = green;
				break;
			case "Warning":
				cssClass = "warning-icon-th";
				statusThIcon = warning;
				break;
		}

		if(cssClass != "info-icon-th"){
			imgTag = <img src={statusThIcon} key={statusThIcon} className={`${cssClass}`} />
		}
		
		return imgTag;
	}
	renderTableData() {
		if(this.state.s3APIStatusJson){
			return this.state.s3APIStatusJson.healthStatus.map((group, index) => {
				let parentTr =
				   <tr className ="alternate-tr-color" key={group.group}>
					  <td><strong>{group.group}</strong></td>
					  <td></td>
					  <td></td>
				   </tr>; 
				let childTr =  group.status.map((api, index) => {
					const dsImgTag = this.getStatusClass(api.dsStatus);
					const sourceSystemImgTag = this.getStatusClass(api.sourceStatus);

					let dsStatus = api.dsStatus.toLowerCase();
					let sourceStatus = api.sourceStatus.toLowerCase();
					dsStatus = dsStatus.charAt(0).toUpperCase() + dsStatus.slice(1);
					sourceStatus = sourceStatus.charAt(0).toUpperCase() + sourceStatus.slice(1);
					let thClass="center-td";
					return  (
						<tr className ="" key={api.api}>
							<td>{api.api}</td>
							<td className={`${thClass}`} title={dsStatus}> {dsImgTag} </td>
							<td className={`${thClass}`} title={sourceStatus}> {sourceSystemImgTag} </td>						
						</tr>);
				})
				parentTr = [parentTr, childTr];
				return parentTr;
			})
		} else {
			return (
				<tr>
					<td colSpan={3} className="center-td">No Status Found.</td>						
				</tr>
			)
		}
	}
	render() {
		let {
			handleViewChange
		} = this.props;
		const [fulleDate, fromNowDate] = this.renderStatusTime();
		return (			
			<div className="container bootstrap-scope h-100">
				<div className="w-100 px-5 mt-5 table-responsive">
					<div className="row">
						<div className="col col-6 col-md-6">
						<h2 id='title' className="justify-content-center">Health Status Dashboard <i title={fulleDate} className="timestamp-size mark">Last Updated : {fromNowDate}</i></h2>
						<span className={`strong underline pointer text-left`} key="incidents" onClick={() => handleViewChange("incidents")}>DDOA-DS Incidents History</span> 
						</div>
						<div className="col col-6 col-md-6">
						<div className="row justify-content-center">
							<div className="col col-9 col-md-9 col-padding" >
							<span className="info-box green" title="Service is up and running." ><img key={green} src={green} className="green-icon" />Good - Service is up and running.</span>
							</div>
							<div className="col col-9 col-md-9 col-padding">
							<span className="info-box yellow" title="Incorrect test data or unable to access the service." ><img src={warning} key={warning} className="warning-icon"/>Warning - Incorrect test data or unable to access the service.</span>
							</div>
							<div className="col col-9 col-md-9 col-padding">
							<span className="info-box red" title="Service is down due to internal error or source system failure." ><img src={failure} className="failure-icon" key={failure}/>Failure - Service is down due to internal error or source system failure.</span>		
							</div>				
							{/* <span className="info-box dark-gray" title="API status is unknown." ><i className="info-icon"></i>-</span>						 */}
						</div>
						</div>
					</div>
					<div className="row">
						<table className="table table-hover health-status-table table-bordered" id='healthStatus'>
							<thead className="thead-dark" ><tr>{this.renderTableHeader()}</tr></thead>
						<tbody>
							{this.renderTableData()}
						</tbody>
					</table>
				</div>
				</div>
			</div>
		);
	}
}

healthDashboard.propTypes = {
	handleViewChange: PropTypes.func.isRequired
};